// Detail builders for the system panel dialogs (part 2).
import { localDateTime } from "../../../lib/datetime";
export const DETAILS_B = {
  sessions: (d, t) => ({
    title: t("system.sessions"),
    summary: [
      [t("system.onlineNow", { count: d.online, minutes: d.online_minutes }), d.online],
      [t("system.trackedUsers"), d.items.length],
    ],
    columns: [t("system.user"), t("system.company"), t("system.country"), t("system.device"), t("system.lastSeen")],
    ids: d.items.map((i) => i.user_id),
    filters: [{ key: "online", label: t("system.onlineOnly"), test: (row) => String(row[0]).startsWith("●") }],
    rows: d.items.map((i) => [
      `${i.online ? "● " : "○ "}${i.name}`,
      i.company,
      i.city ? `${i.country} · ${i.city}` : i.country,
      i.device,
      localDateTime(i.last_seen_at),
    ]),
  }),

  crons: (d, t) => ({
    title: t("system.crons"),
    summary: [
      [t("system.jobs"), d.jobs.length],
      [t("system.failedJobs"), d.jobs.filter((j) => !j.ok).length],
    ],
    columns: [t("system.job"), t("system.lastRun"), t("system.duration"), t("system.result")],
    rows: d.jobs.map((j) => [
      j.job,
      localDateTime(j.at),
      `${j.ms} ms`,
      j.ok ? "OK" : `FAIL · ${j.detail || ""}`,
    ]),
  }),

  companies: (d, t) => ({
    title: t("system.companies", { days: d.days }),
    summary: [
      [t("system.companiesTracked"), d.companies_tracked],
      [t("system.requests"), d.items.reduce((sum, i) => sum + i.requests, 0)],
      [t("system.tokens"), d.items.reduce((sum, i) => sum + i.tokens, 0)],
    ],
    columns: [t("system.company"), t("system.plan"), t("system.requests"), t("system.tokens"), t("system.avgMs")],
    rows: d.items.map((c) => [c.company, c.plan || "—", c.requests, c.tokens, `${c.avg_ms} ms`]),
  }),

  alerts: (d, t) => ({
    title: t("system.alerts"),
    summary: d.rules.map((r) => [t(`system.rule_${r.rule}`, r.rule), `${r.times}×`]),
    columns: [t("system.rule"), t("system.value"), t("system.limit"), t("system.when")],
    rows: d.events.map((e) => [
      t(`system.rule_${e.rule}`, e.rule),
      `${e.value}%`,
      `${e.limit}%`,
      localDateTime(e.at),
    ]),
  }),

  trends: (d, t) => ({    title: t("system.trends", { days: d.days }),
    summary: [
      [t("system.requests"), d.points.reduce((sum, p) => sum + p.requests, 0)],
      [t("system.serverErrors"), d.points.reduce((sum, p) => sum + p.errors, 0)],
    ],
    columns: [t("system.day"), t("system.requests"), t("system.avgMs"), t("system.serverErrors")],
    rows: d.points.map((p) => [p.date, p.requests, `${p.avg_ms} ms`, p.errors]),
  }),
};
